import React from "react";
import LayoutSettings from "../LayoutSettings/LayoutSettings";
import SelectTheme from "../SelectLayout/SelectComponent/SelectTheme";
import Background from "../LayoutSettings/Background";
import Banner from "../LayoutSettings/Banner/Banner";
import CardStyle from "../LayoutSettings/CardStyle";
import ThemeSetting from "../LayoutSettings/ThemeSettings";
import HashtagHighlighter from "../LayoutSettings/HashtagHighlighter";
import PostAnimation from "../LayoutSettings/PostAnimation";
import { Link } from "react-router-dom";
import InteractionWall from "../LayoutSettings/InteractionWall";
import QrSetting from "../LayoutSettings/QrSetting";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";


const SettingPreview = ({ activeLayout, themeUpdateData, props }) => { 
    switch (props.activesettingLayout) {
        case 1:
            return <SelectTheme activeLayout={activeLayout} themeUpdateData={themeUpdateData} {...props} />;
        case 2:
            return <Background {...props} />;
        case 3:
            return <Banner {...props} />;
        case 4:
            return <CardStyle {...props} />;
        case 5:
            return <ThemeSetting {...props} />;
        case 7:
             return <HashtagHighlighter  {...props} />; 
        case 8:
             return <InteractionWall  {...props} />;  
        case 9:
             return <QrSetting  {...props} />;       
        default:
            return <PostAnimation {...props} />;
    }
}

class SelectLayout extends React.Component{

    constructor(props){
        super(props)

        this.state = {
            activeLayout : [],
            themeLayout : 0,
            selectedtheme: null,
            themeId: null,
        }
    }

    componentDidMount(){
       this.themeUpdate();
     }


     themeUpdateData =(id, themeName)=> {
        this.setState({themeLayout: id, selectedtheme: themeName});
     }
    
     themeUpdate(){ 
        const { wallData } = this.props;

        wallData.themeData.forEach((parent) => {
            parent.theme.forEach((child) => {
                 if(child.id == wallData.wall.Personalization.ThemeRule.themeId){
                    this.setState({themeLayout: parent.index, selectedtheme: child.name, themeId: wallData.wall.Personalization.ThemeRule.themeId })
                }
            });
        });
     }

     componentDidUpdate(nextProps, previousProps){
        const { wallData } = nextProps;
        if(wallData.wall.Personalization.ThemeRule.themeId != this.state.themeId) this.themeUpdate();
     }


    render(){

        const { activeSetting, activesettingLayout ,wallData, product  } = this.props;
        const { activeLayout, themeLayout, selectedtheme } = this.state;
        //console.log('UgcSettings2')

        return(
          <>
          { !activesettingLayout || activesettingLayout == 6 ? 
             <>
                <div className="select-layout p-3 pb-0">
                    <div className="pb-3">
                        <Link to={`/wall/index/${wallData.wall.id}`} ><FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={'me-2 text-dark'} /></Link>
                        <label className="text-dark fw-bold"> Select Layout </label>
                    </div>
                    <div className="template_aside_inner"> 

                     { wallData && Object.keys(wallData) && wallData.themeData && wallData.themeData.map((value)=>{   
                        return <div onClick={()=>{ this.setState({activeLayout : value},()=>activeSetting(1,value))}} className="flex-column w-100 btn-group mb-2" key={value.index}>
                                <input className="btn-check" type="radio" value="option1" name="themeName" autoComplete="off"/>
                                <label className={`bg-white btn ${themeLayout == value.index ? 'btn-outline-dark active' : 'btn-outline-secondary'} py-2 px-2`}>
                                    <div className="d-flex align-items-center position-relative">
                                        <div className="symbol symbol-40 flex-shrink-0 me-2 text-gray-400">
                                        {value.index == 1 ? <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                            <g id="Group_9245" data-name="Group 9245" transform="translate(3494 -21353.195)">
                                                <rect id="Image_635" data-name="Image 635" width="13" height="22" rx="1" transform="translate(-3494 21353.195)" fill="#e4e6ef"/>
                                                <rect id="Image_640" data-name="Image 640" width="12" height="17" rx="1" transform="translate(-3466 21353.195)" fill="#e4e6ef"/>
                                                <rect id="Image_636" data-name="Image 636" width="11" height="14" rx="1" transform="translate(-3479 21353.195)" fill="#e4e6ef"/>
                                                <rect id="Image_637" data-name="Image 637" width="11" height="24" rx="1" transform="translate(-3479 21369.195)" fill="#e4e6ef"/>
                                                <rect id="Image_641" data-name="Image 641" width="12" height="11" rx="1" transform="translate(-3466 21372.195)" fill="#e4e6ef"/>
                                                <rect id="Image_639" data-name="Image 639" width="13" height="16" rx="1" transform="translate(-3494 21377.195)" fill="#e4e6ef"/>
                                                <rect id="Image_642" data-name="Image 642" width="12" height="8" rx="1" transform="translate(-3466 21385.195)" fill="#e4e6ef"/>
                                            </g>
                                        </svg> : value.index ==  2 ? <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                            <g id="Group_9385" data-name="Group 9385" transform="translate(3763 -21659.227)">
                                                <rect id="Image_635" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3763 21659.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-2" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3749 21659.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-3" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3735 21659.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-4" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3763 21673.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-5" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3749 21673.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-6" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3735 21673.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-7" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3763 21687.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-8" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3749 21687.227)" fill="#e4e6ef"/>
                                                <rect id="Image_635-9" data-name="Image 635" width="12" height="12" rx="1" transform="translate(-3735 21687.227)" fill="#e4e6ef"/>
                                            </g>
                                            </svg> : value.index == 3 ? <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1017_22)">
                                            <path d="M12.1738 16H4.17383C3.62154 16 3.17383 16.4477 3.17383 17V27C3.17383 27.5523 3.62154 28 4.17383 28H12.1738C12.7261 28 13.1738 27.5523 13.1738 27V17C13.1738 16.4477 12.7261 16 12.1738 16Z" fill="#E4E6EF"/>
                                            <path d="M24.1992 16H16.1992C15.6469 16 15.1992 16.4477 15.1992 17V27C15.1992 27.5523 15.6469 28 16.1992 28H24.1992C24.7515 28 25.1992 27.5523 25.1992 27V17C25.1992 16.4477 24.7515 16 24.1992 16Z" fill="#E4E6EF"/>
                                            <path d="M36.2246 16H28.2246C27.6723 16 27.2246 16.4477 27.2246 17V27C27.2246 27.5523 27.6723 28 28.2246 28H36.2246C36.7769 28 37.2246 27.5523 37.2246 27V17C37.2246 16.4477 36.7769 16 36.2246 16Z" fill="#E4E6EF"/>
                                            <path d="M1.80371 24.0493L0.00390625 21.9888L0.0908203 21.8892L1.80762 19.9517C1.83597 19.9192 1.87105 19.8936 1.91016 19.8755C1.94927 19.8574 1.99158 19.8468 2.03467 19.8462C2.07997 19.8466 2.12447 19.8583 2.16553 19.8774C2.20658 19.8966 2.24351 19.9231 2.27295 19.9575V19.9634C2.32572 20.0316 2.35363 20.1174 2.35254 20.2036C2.35145 20.2899 2.32108 20.3731 2.2666 20.4399L0.879883 21.9946L2.2666 23.561C2.32012 23.63 2.34912 23.714 2.34912 23.8013C2.34912 23.8885 2.32012 23.9726 2.2666 24.0415C2.23838 24.0757 2.2032 24.1047 2.16309 24.1235C2.12297 24.1424 2.07899 24.151 2.03467 24.1509C1.99119 24.1515 1.94804 24.1429 1.9082 24.1255C1.86836 24.1081 1.83279 24.0816 1.80371 24.0493Z" fill="#959595"/>
                                            <path d="M38.1363 24.0278C38.08 23.9623 38.0489 23.8799 38.0489 23.7935C38.0489 23.707 38.08 23.6226 38.1363 23.5571L39.5172 21.9849L38.1363 20.436C38.0796 20.3705 38.0472 20.2883 38.045 20.2017C38.0429 20.115 38.0708 20.0297 38.1241 19.9614C38.1528 19.9257 38.189 19.8957 38.2301 19.8755C38.2712 19.8553 38.3161 19.8451 38.3619 19.8442C38.4064 19.8444 38.4507 19.8543 38.4908 19.8735C38.531 19.8927 38.5663 19.921 38.5944 19.9556L40.3942 21.9849L40.3072 22.0845L38.589 24.0396C38.5298 24.1013 38.449 24.1369 38.3634 24.1392C38.3196 24.1395 38.2758 24.1291 38.2364 24.1099C38.1971 24.0906 38.163 24.0627 38.1363 24.0278Z" fill="#959595"/>
                                            </g>
                                            </svg> : value.index == 4 ? <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                                <g id="Group_9245" data-name="Group 9245" transform="translate(3494 -21353.195)">
                                                    <rect id="Image_635" data-name="Image 635" width="19" height="40" rx="1" transform="translate(-3494 21353.195)" fill="#e4e6ef"/>
                                                    <rect id="Image_637" data-name="Image 637" width="19" height="40" rx="1" transform="translate(-3473 21353.195)" fill="#e4e6ef"/>
                                                </g>
                                                </svg> : null}
                                        


                                        </div>
                                        <div className="overflow-hidden">
                                            <p className="mb-1 text-dark text-ellipsis text-start">{value.layout} {(selectedtheme && themeLayout == value.index) ? `: ${selectedtheme}` : null}</p>
                                            <p className="mb-0 text-ellipsis text-start">
                                                {
                                                    value.product && value.product.split(',').map((product, index)=>{
                                                        return(<label className="label label-inline font-weight-bolder font-size-xs mb-0 me-1" key={`${value.index}-product-use-${index}`}>{product}</label>)
                                                    })
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        })}
                    </div> 
                </div>
                <LayoutSettings  {...this.props}/>
            </>
                :
              <SettingPreview themeUpdateData={this.themeUpdateData} activeLayout={activeLayout} props={this.props}/>
            }
        </>  
      )
    }
}

export default SelectLayout;